import React, { useEffect, useState } from 'react';
import Axios from 'axios';
import Pagination from 'react-js-pagination';
import News from '../../components/NewsContainer/News';
import { BASE_URL } from 'utils/constants';
import { useSelector } from 'react-redux';
import { makeSelectLanguage } from 'containers/App/selectors';

const ArticlesPage = () => {
  const [articles, setArticles] = useState([]);
  const [activePage, setActivePage] = useState(1);
  const [totalPages, setTotalPages] = useState(0);
  const language = useSelector(makeSelectLanguage());

  useEffect(() => {
    if (language === 'en-us') {
      Axios.get(`${BASE_URL}/api/articles?page=1&en=true`).then(({ data }) => {
        setArticles(data.data);
        setActivePage(data.current_page);
        setTotalPages(data.total);
      });
    } else {
      Axios.get(`${BASE_URL}/api/articles?page=1`).then(({ data }) => {
        setArticles(data.data);
        setActivePage(data.current_page);
        setTotalPages(data.total);
      });
    }
  }, [language]);

  const handlePageChange = pageNumber => {
    Axios.get(`${BASE_URL}/api/articles?page=${pageNumber}`).then(
      ({ data }) => {
        console.log(data)
        setArticles(data.data);
        setActivePage(data.current_page);
        setTotalPages(data.total);
      }
    );
  };
  return (
    <div className="news-container center-container">
      {articles.length > 0 &&
        articles.map((article, key) => {
          return <News key={key} article={article}></News>;
        })}
      {articles && (
        <div className="center-container d-flex justify-content-center">
          <Pagination
            activePage={activePage}
            itemsCountPerPage={12}
            totalItemsCount={totalPages}
            pageRangeDisplayed={5}
            onChange={handlePageChange}
            itemClass="page-item"
            linkClass="page-link"
          />
        </div>
      )}
    </div>
  );
};

export default ArticlesPage;
